/**
 * @flow
 * @relayHash 10b6063f28c7e0c4b3592bf82e334721
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CrawlErrorsTable_project$ref = any;
export type FilterOperator = "AND" | "OR" | "%future added value";
export type TextFilterOperator = "CONTAINS" | "NOT_CONTAINS" | "REGEXP" | "%future added value";
export type TextFilters = {
  operator: FilterOperator,
  values?: ?$ReadOnlyArray<?TextFilter>,
};
export type TextFilter = {
  operator: TextFilterOperator,
  value: string,
};
export type CrawlErrorsTable_RefetchQueryVariables = {|
  offset?: ?number,
  limit?: ?number,
  url?: ?TextFilters,
  sourceUrl?: ?TextFilters,
  errors?: ?$ReadOnlyArray<?string>,
  host: string,
|};
export type CrawlErrorsTable_RefetchQueryResponse = {|
  +project: ?{|
    +$fragmentRefs: CrawlErrorsTable_project$ref
  |}
|};
export type CrawlErrorsTable_RefetchQuery = {|
  variables: CrawlErrorsTable_RefetchQueryVariables,
  response: CrawlErrorsTable_RefetchQueryResponse,
|};
*/


/*
query CrawlErrorsTable_RefetchQuery(
  $offset: Int
  $limit: Int
  $url: TextFilters
  $sourceUrl: TextFilters
  $errors: [String]
  $host: String!
) {
  project(host: $host) {
    ...CrawlErrorsTable_project_Ndfw0
    id
  }
}

fragment CrawlErrorsTable_project_Ndfw0 on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        crawlErrors(offset: $offset, limit: $limit, url: $url, errors: $errors, sourceUrl: $sourceUrl) {
          count
          edges {
            node {
              ...CrawlErrorsRow_issue
              id
            }
          }
        }
        countCodesCrawlErrors(url: $url, sourceUrl: $sourceUrl) {
          error
          count
        }
        id
      }
    }
  }
}

fragment CrawlErrorsRow_issue on CrawlError {
  id
  type
  source_url
  severity
  error
  url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "url",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sourceUrl",
    "type": "TextFilters",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "errors",
    "type": "[String]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Variable",
  "name": "sourceUrl",
  "variableName": "sourceUrl",
  "type": "TextFilters"
},
v3 = {
  "kind": "Variable",
  "name": "url",
  "variableName": "url",
  "type": "TextFilters"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "error",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "CrawlErrorsTable_RefetchQuery",
  "id": null,
  "text": "query CrawlErrorsTable_RefetchQuery(\n  $offset: Int\n  $limit: Int\n  $url: TextFilters\n  $sourceUrl: TextFilters\n  $errors: [String]\n  $host: String!\n) {\n  project(host: $host) {\n    ...CrawlErrorsTable_project_Ndfw0\n    id\n  }\n}\n\nfragment CrawlErrorsTable_project_Ndfw0 on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        crawlErrors(offset: $offset, limit: $limit, url: $url, errors: $errors, sourceUrl: $sourceUrl) {\n          count\n          edges {\n            node {\n              ...CrawlErrorsRow_issue\n              id\n            }\n          }\n        }\n        countCodesCrawlErrors(url: $url, sourceUrl: $sourceUrl) {\n          error\n          count\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment CrawlErrorsRow_issue on CrawlError {\n  id\n  type\n  source_url\n  severity\n  error\n  url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "CrawlErrorsTable_RefetchQuery",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CrawlErrorsTable_project",
            "args": [
              {
                "kind": "Variable",
                "name": "errors",
                "variableName": "errors",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "limit",
                "variableName": "limit",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "offset",
                "variableName": "offset",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "sourceUrl",
                "variableName": "sourceUrl",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "url",
                "variableName": "url",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CrawlErrorsTable_RefetchQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0,
                "type": "Int"
              }
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "crawlErrors",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "errors",
                            "variableName": "errors",
                            "type": "[String]"
                          },
                          {
                            "kind": "Variable",
                            "name": "limit",
                            "variableName": "limit",
                            "type": "Int"
                          },
                          {
                            "kind": "Variable",
                            "name": "offset",
                            "variableName": "offset",
                            "type": "Int"
                          },
                          v2,
                          v3
                        ],
                        "concreteType": "CrawlErrorsConnection",
                        "plural": false,
                        "selections": [
                          v4,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CrawlErrorsEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CrawlError",
                                "plural": false,
                                "selections": [
                                  v5,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "type",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "severity",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v6,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countCodesCrawlErrors",
                        "storageKey": null,
                        "args": [
                          v2,
                          v3
                        ],
                        "concreteType": "CountError",
                        "plural": true,
                        "selections": [
                          v6,
                          v4
                        ]
                      },
                      v5
                    ]
                  }
                ]
              }
            ]
          },
          v5
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '472758a4a6b07c9415cdd501c67168d1';
module.exports = node;
